import { t } from '../i18n/strings'
import {
  ADSENSE_CLIENT_ID,
  ADSENSE_SLOT_BOTTOM,
  ADSENSE_SLOT_TOP,
  adsenseEnabled,
} from '../lib/adsense'
import { el } from './dom'

declare global {
  interface Window {
    adsbygoogle?: unknown[]
  }
}

const SCRIPT_ID = 'holecard-adsense-script'

export function loadAdSenseScript(): void {
  if (!adsenseEnabled) return
  if (document.getElementById(SCRIPT_ID)) return

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.async = true
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT_ID}`
  script.crossOrigin = 'anonymous'
  document.head.appendChild(script)
}

export function adUnit(slot: string, label?: string): HTMLElement {
  const ui = t()
  const resolved = label ?? ui.adArea
  const ready = adsenseEnabled && slot.length > 0
  if (!ready) {
    // Keep structure for future AdSense, but parent uses display:none when inactive.
    return el('div', {
      className: 'adPlaceholder',
      attrs: { 'aria-label': resolved, 'aria-hidden': 'true' },
    }, [
      el('span', { text: resolved }),
      el('small', { text: ui.adPlaceholderHint }),
    ])
  }

  const wrap = el('div', { className: 'adWrap adLive' })
  const ins = el('ins', {
    className: 'adsbygoogle',
    attrs: {
      style: 'display:block',
      'data-ad-client': ADSENSE_CLIENT_ID,
      'data-ad-slot': slot,
      'data-ad-format': 'auto',
      'data-full-width-responsive': 'true',
    },
  })
  wrap.append(ins)
  queueMicrotask(() => {
    try {
      ;(window.adsbygoogle = window.adsbygoogle || []).push({})
    } catch {
      // ignore duplicate pushes
    }
  })
  return wrap
}

/** Top slot: DOM kept for AdSense; no layout cost while inactive (see `.adTop`). */
export function topAd(): HTMLElement {
  const live = adsenseEnabled && ADSENSE_SLOT_TOP.length > 0
  return el(
    'div',
    {
      className: live ? 'adTop adLive' : 'adTop',
      attrs: { 'aria-hidden': 'true' },
    },
    [adUnit(ADSENSE_SLOT_TOP, t().adTop)],
  )
}

/** Bottom slot: DOM kept for AdSense; no layout cost while inactive. */
export function bottomAd(): HTMLElement {
  const live = adsenseEnabled && ADSENSE_SLOT_BOTTOM.length > 0
  return el(
    'div',
    {
      className: live ? 'adBottom adLive' : 'adBottom',
      attrs: { 'aria-hidden': 'true' },
    },
    [adUnit(ADSENSE_SLOT_BOTTOM, t().adBottom)],
  )
}
